import CloudinaryImage from "components/cloudinary-image"
import styled from "styled-components"
import { minWidth } from "utils"

export const AnimatedSliderSection = styled.div`
  padding: 0 1rem;
  margin-top: 0;
  position: relative;
  z-index: 3;
  overflow: hidden;
  width: 100%;
  max-width: 100vw;

  ${minWidth.tablet`
    padding: 0 4rem;
    margin: 4rem 0;
    overflow: visible;
  `}

  ${minWidth.desktop`
    margin: 2rem 0;
    padding: 0;
    margin-bottom: 10rem;
    overflow: visible;
  `}
`

export const HeadingRow = styled.div`
  display: none;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;

  ${minWidth.tablet`
    display: flex;
  `}
`

export const Container = styled.div`
  width: 100%;
  height: 29rem;
  position: relative;
  perspective: 1400px;
  perspective-origin: center center;
  z-index: 1;
  touch-action: pan-y;

  @media (min-width: 457px) {
    height: 32rem;
  }

  ${minWidth.mobile`
    height: 34rem;
  `}

  ${minWidth.tablet`
    height: 42rem;
    perspective: 1900px;
  `}

  ${minWidth.desktop`
    height: 48rem;
    perspective: 2000px;
  `}
  overflow: visible;
`

export const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
`

export const Carousel = styled.div`
  width: 100%;
  position: absolute;
  transform-style: preserve-3d;
  transition: transform 1s;
  transform: rotateY(${({ rotation }) => rotation}deg);
  overflow: visible;
  z-index: 2;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`

export const SlideWrapper = styled.div`
  display: flex;
  justify-content: center;
  transform-style: preserve-3d;
  transform: rotateY(${({ angle }) => angle}deg) translateZ(10rem) translateY(7rem)
    rotateY(-${({ angle }) => angle}deg);

  ${minWidth.tabletLow`
    transform: rotateY(${({ angle }) => angle}deg)
      translateZ(13rem)
      translateY(6.5rem)
      rotateY(-${({ angle }) => angle}deg);
  `}

  ${minWidth.desktop`
    transform: rotateY(${({ angle }) => angle}deg)
      translateZ(16rem)
      translateY(6rem)
      rotateY(-${({ angle }) => angle}deg);
  `}

  ${minWidth.desktopL`
    transform: rotateY(${({ angle }) => angle}deg)
      translateZ(16rem)
      translateY(6rem)
      rotateY(-${({ angle }) => angle}deg);
  `}

  ${minWidth.desktopXXL`
    transform: rotateY(${({ angle }) => angle}deg)
      translateZ(18rem)
      translateY(6rem)
      rotateY(-${({ angle }) => angle}deg);
  `}
`

export const Item = styled.div`
  display: block;
  position: absolute;
  width: 85%;
  border-radius: 8px;
  transition: transform 1s;
  transform: rotateY(${({ rotation }) => -rotation}deg);
  overflow: visible;
  background-color: aliceblue;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  ${minWidth.tablet`
    width: 80%;
  `}

  ${minWidth.desktopL`
    max-width: 68rem;
  `}
`

export const MediaContainer = styled.div`
  position: relative;
  height: 19rem;
  border-radius: 1rem;
  overflow: hidden;
  margin: 0 auto;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  @media (min-width: 457px) {
    height: 22rem;
  }

  ${minWidth.mobile`
    height: 24rem;
  `}

  ${minWidth.tablet`
    height: 32rem;
    border-radius: 1rem;
  `}

  ${minWidth.desktop`
    height: 38rem;
    border-radius: 1rem;
  `}


  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.7) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0.8) 100%
    );
    opacity: ${({ isActive }) => (isActive ? 0 : 1)};
    transition: opacity 0.3s ease;
    pointer-events: none;
    z-index: 2;
    border-radius: 1rem;
  }
`

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
  background: #000;
`

export const ImageElement = styled(CloudinaryImage)`
  width: 100%;
  height: 100%;
`

export const CroppedImageElement = styled.div`
  width: 100%;
  height: 100%;
  display: block;

  & > div {
    width: 100%;
    height: 100%;

    picture {
      width: 100%;
      height: 100%;
      display: block;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
    }
  }
`

export const ContentOverlay = styled.div`
  position: absolute;
  top: 27rem;
  left: 0;
  right: 0;
  min-height: 9rem;
  z-index: 5;
  color: ${({ theme }) => theme?.colors?.text?.primary || "#333"};
  background: transparent;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;

  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: translateY(${({ isActive }) => (isActive ? "0" : "17.0170875px")});
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: ${({ isActive }) => (isActive ? "all" : "none")};

  ${minWidth.tablet`
    top: 34rem;
  `}

  ${minWidth.desktop`
    top: 40rem;
  `}
`

export const CategoryTag = styled.div`
  display: inline-block;
  font-size: 1.2rem;
  text-transform: uppercase;
  color: #2260b2;
  background: transparent;
  font-weight: 500;
  margin-bottom: 1.4rem;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: translateY(${({ isActive }) => (isActive ? "0" : "17.0170875px")});
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${({ isActive }) => (isActive ? "0.1s" : "0s")};
`

export const Headline = styled.h3`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 2.2rem;
  margin-bottom: 0;
  color: ${({ theme }) => theme?.colors?.text?.primary || "#333"};
  text-shadow: none;

  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: translateY(${({ isActive }) => (isActive ? "0" : "17.0170875px")});
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${({ isActive }) => (isActive ? "0.2s" : "0s")};

  ${minWidth.tablet`
    font-size: 2.4rem;
    line-height: 2.8rem;
  `}
  ${minWidth.desktop`
    font-size: 3rem;
    line-height: 3.4rem;
    font-weight: 400;
  `}
`

export const Description = styled.div`
  font-size: 1.2rem;
  line-height: 1.6rem;
  flex: 1 0 auto;
  margin: 0.75rem 0;
  color: ${({ theme }) => theme?.colors?.text?.primary || "#333"};
  text-shadow: none;

  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: translateY(${({ isActive }) => (isActive ? "0" : "17.0170875px")});
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${({ isActive }) => (isActive ? "0.3s" : "0s")};

  :empty {
    margin: 0.75rem 0;
  }

  ${minWidth.tablet`
    font-size: 1.4rem;
    line-height: 2rem;
  `}
  ${minWidth.desktop`
    font-size: 1.6rem;
    line-height: 2.1rem;
  `}
`

export const AuthorByline = styled.p`
  font-size: 1.2rem;
  line-height: 1.2rem;
  color: ${({ theme }) => theme?.colors?.text?.primary || "#333"};
  text-transform: capitalize;
  margin-top: 1.2rem;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: translateY(${({ isActive }) => (isActive ? "0" : "1.7rem")});
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${({ isActive }) => (isActive ? "0.4s" : "0s")};

  ${minWidth.tablet`
    line-height: 1.3rem;
    margin-top: 1.6rem;
  `}

  ${minWidth.desktop`
    font-size: 1.4rem;
    margin-top: 2rem;
  `}
`

export const NavigationArrow = styled.button`
  position: absolute;
  top: 60%;

  transform: translateY(-50%);
  ${({ position }) => (position === "left" ? "left: 0.5rem;" : "right: 0.5rem;")}
  width: 2.8rem;
  height: 2.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 4;
  border-radius: 50%;
  border: none;
  background: transparent;

  img {
    width: 1.6rem;
    height: 1.6rem;
  }

  &:focus-visible {
    outline: 3px solid #ffffff;
    outline-offset: 2px;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.6);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: translateY(-50%) scale(1);
  }

  ${minWidth.desktop`
  top: 55%;
    ${({ position }) => (position === "left" ? "left: 1rem;" : "right: 1rem;")}
    width: 4rem;
    height: 4rem;

    img {
      width: 2rem;
      height: 2rem;
    }
  `}
`

export const PaginationContainer = styled.div`
  position: absolute;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.6rem;
  z-index: 4;

  ${minWidth.tablet`
    bottom: 1.6rem;
    left: 50%;
    transform: translateX(-50%);
  `}
  ${minWidth.desktop`
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
  `}
`

export const PaginationDot = styled.button`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: ${({ isActive }) => (isActive ? "none" : "1px solid #ffffff")};
  background: ${({ isActive }) => (isActive ? "rgba(255, 255, 255, 0.9)" : "transparent")};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ffffff;
    background: ${({ isActive }) =>
      isActive ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.2)"};
    transform: scale(1.1);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px #ffffff, 0 0 0 5px rgba(0, 0, 0, 0.7);
    transform: scale(1.15);
  }

  ${minWidth.tablet`
    width: 1.2rem;
    height: 1.2rem;
  `}
`

export const ContentBelowCarousel = styled.div`
  width: 85%;
  position: relative;
  padding: 0.5rem 0;
  color: ${({ theme }) => theme?.colors?.text?.primary || "#333"};
  background: transparent;
  display: flex;
  flex-direction: column;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;

  ${minWidth.tabletLow`
    width: 80%;
    max-width: 36rem;
  `}

  ${minWidth.tablet`
    width: 80%;
    max-width: unset;
  `}

  ${minWidth.desktopL`
    max-width: 68rem;
  `}
`

export const ArrowsWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 85%;
  height: 100%;
  pointer-events: none;
  z-index: 4;

  ${minWidth.tabletLow`
    height: 100%;
    width: 80%;
  `}

  ${minWidth.desktopL`
    max-width: 68rem;
  `}
`
